/** Joins missing field labels (Colombian Spanish copy) into one validation message when saving. */
export function joinMissingFieldLabelsEs(labels: string[]): string {
  const u = [...new Set(labels.map((s) => s.trim()).filter(Boolean))];
  if (u.length === 0) return '';
  const head = 'Para guardar, complete: ';
  if (u.length === 1) return `${head}${u[0]}.`;
  if (u.length === 2) return `${head}${u[0]} y ${u[1]}.`;
  const last = u.at(-1)!;
  return `${head}${u.slice(0, -1).join(', ')} y ${last}.`;
}
